import { postJSON } from '@catalogo/core-http';

export default config => async (_, args) => {
  const body = {
    customer_id: args.id,
    access_token: args.token,
    postal_code: args.cep,
  };

  const result = await postJSON(`https://acom.supermercadonow.com/api/v2/auth/americanas`, JSON.stringify(body), {
    'X-Requested-With': 'XMLHttpRequest',
  });

  return await result.json();
};
